// extracted by mini-css-extract-plugin
module.exports = {"skip-links":"styles_skip-links__yatPk","skip-links__anchor":"styles_skip-links__anchor__IL9PS"};